var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tnc-wrapper" },
    [
      _vm._m(0),
      _vm._m(1),
      _vm._m(2),
      _vm._m(3),
      _vm._m(4),
      _vm._m(5),
      _vm._m(6),
      _vm.isMobile ? _c("BurgerMenu") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h2", [
      _c("span", { staticStyle: { "font-size": "16pt" } }, [
        _vm._v("이용 약관"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h4", [
      _c("strong", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("일반 규칙"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "본 웹사이트는 거주하는 관할권에 따라 법적 연령에 도달한 개인에게만 제한됩니다."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "본 웹사이트는 웹사이트를 이용하는 모든 사용자가 위반한 국내법, 연방법 또는 국제법에 대해 책임을 지지 않습니다."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "사용자는 자신의 행동에 책임을 져야 하며, 주법이나 법적 문제를 포함한 해당 국가의 법률을 준수해야 합니다."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "모든 에이전트는 각자의 회원 계정에 대한 책임을 져야 하며, 자신이 제출한 모든 확인된 베팅을 존중해야 합니다."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "에이전트는 당사 웹사이트의 파트너가 아닙니다. 따라서 당사 웹사이트는 플레이어와 에이전트 간의 불일치나 분쟁에 대해 책임을 지지 않습니다."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "사용자는 자신의 사용자 ID와 비밀번호를 무단 사용으로부터 보호할 책임이 있습니다. 사용자의 사용자 ID와 비밀번호가 도난당하거나 유출된 경우, 사용자는 즉시 담당자에게 연락해야 합니다. 담당자는 사용자의 사용자 ID와 비밀번호를 변경해 드립니다."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "사용자 ID와 비밀번호가 도난당한 경우, 사용자는 각자의 계정에 대한 책임을 져야 하며 제출된 모든 확인된 베팅을 존중해야 합니다."
              ),
            ]),
          ]),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h4", [
      _c("strong", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("게임 규칙"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "본 웹사이트에서 결정된 경기 결과는 최종적이며 구속력을 가집니다."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "모든 분쟁 발생 시, 당사 웹사이트 운영진과 플레이어는 당사 웹사이트 거래 로그 데이터베이스가 분쟁의 최종 결정권자 역할을 한다는 데 동의해야 합니다. 모든 분쟁은 경기 결과가 결정된 날 이내에 제기되어야 합니다. 경기 당일 이후에는 어떠한 청구도 받아들여지지 않습니다."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "플레이어는 자신의 모든 계정 거래의 정확성을 확인할 전적인 책임을 집니다."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "컴퓨터로 베팅을 제출하기 전에 베팅 내용에 오류, 오류 또는 누락된 부분이 없는지 반드시 검토해 주세요. 컴퓨터로 베팅이 승인되면 변경이나 취소가 불가능합니다."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "당사는 이러한 이용 약관을 위반하거나, 사기 행위에 가담하거나, 불법 침입, 공격, 위조, 표준 규칙을 훼손하거나, 신디케이트 베팅에 연루된 고객 계정을 동결하거나 취소할 권리를 보유하며, 이로 인해 발생하는 모든 계정 잔액은 사전 통지 없이 동결되고 몰수됩니다."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "당사는 조직적 베팅, 공모 베팅, 담합, 사기, 시스템 악용, 기술적 오류 또는 잘못된 배당률의 악용, 기타 부당한 이익을 얻기 위한 행위와 관련된 것으로 확인된 모든 베팅 또는 베팅 티켓을 무효 처리하거나 취소할 권리를 보유합니다. 관련 당첨금은 회수될 수 있으며, 해당 계정은 정지되거나 폐쇄될 수 있습니다."
              ),
            ]),
          ]),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h4", [
      _c("strong", [
        _c("span", { staticStyle: { "font-size": "12pt" } }, [
          _vm._v("한도 및 책임"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "앞서 언급한 일반성을 해치지 않고, 당사 웹사이트는 방해 행위, 불가항력 및/또는 당사 웹사이트 중앙 컴퓨터 시스템이나 기록 또는 그 일부의 고장, 손상 또는 파괴 사건, 또는 통신 또는 데이터 전송 시스템의 고장으로 인한 지연, 손실, 오류, 누락 또는 기타 사항, 또는 특정 경주에 대한 참가 신청을 받지 못하는 결과를 초래하는 지연이 발생한 경우 어떠한 사람에게도 책임을 지지 않습니다."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "당사 웹사이트는 천재지변, 적대 행위 발생, 폭동, 시민 불안, 테러 행위, 정부 또는 당국의 행위(면허 또는 동의의 거부 또는 취소 포함), 화재, 폭발, 홍수, 도난, 악의적 손상, 파업, 직장폐쇄 및 모든 종류의 산업 활동으로 인해 발생하는 손실에 대해 책임을 지지 않습니다."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "네트워크 연결, 통신, 시스템 또는 인적 오류로 인해 이중 베팅 승인, 베팅 확인 불가, 게임 시작 후 베팅 등 베팅 관련 문제가 발생하는 경우, 당사는 해당 오류 발생 시 개별적으로 조치를 취하고 오류를 수정하기 위한 모든 조치를 취할 권리가 있습니다. 당사는 이러한 오류와 관련하여 귀하 또는 제3자에게 어떠한 책임도 지지 않습니다. 이러한 오류가 발생했음에도 불구하고 업라인에 보고하지 않고 계속 베팅하는 경우, 오류가 재발하더라도 모든 승패 결과에 대한 책임을 져야 하며, 모든 승패 결과는 존중됩니다."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "본 규칙과 규정은 당사자 간의 전체 합의와 이해를 구성합니다."
              ),
            ]),
          ]),
        ]
      ),
      _c(
        "li",
        {
          staticStyle: { "list-style-type": "decimal", "font-size": "10.5pt" },
        },
        [
          _c("p", [
            _c("span", { staticStyle: { "font-size": "10.5pt" } }, [
              _vm._v(
                "본 규칙 및 규정의 영어 버전과 다른 언어 버전 사이에 불일치 사항이 있는 경우, 영어 버전이 다른 언어 버전보다 우선하며 정확하고 유효한 것으로 간주됩니다."
              ),
            ]),
          ]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }